var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('StackedBarChart',{attrs:{"chart-data":_vm.chartData,"view-box":[800, 200]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }